import RaioAtuacaoModel from "./RaioAtuacaoModel";

export default class LojaModel {
  public lojaId: string = "";
  public lojaIdOba: string = "";
  public nome: string = "";
  public logradouro: string = "";
  public numero: string = "";
  public complemento: string = "";
  public bairro: string = "";
  public cidade: string = "";
  public uf: string = "";
  public cep: string = "";
  public cepInicio: string = "";
  public cepFim: string = "";
  public telefones: string = "";
  public funcionamento: string = "";
  public latitude: number = 0;
  public longitude: number = 0;
  public retiradaDrivethru: boolean = false;
  public retiradaNormal: boolean = false;
  public retiradaModal: boolean = false;
  public ordemExibicao: number = 0;
  public retirada: boolean = false;
  public cepDelivery: string = "";
  public raioAtuacao: number = 0;
  public raiosAtuacao: RaioAtuacaoModel[] = [];

  public static toModel(item: any): LojaModel {
    return {
      lojaId: item.StoreID.toString(),
      lojaIdOba: item.StoreIDOba.toString(),
      nome: item.Name,
      cepInicio: item.ZipCodeInit,
      cepFim: item.ZipCodeEnd,
      logradouro: item.Address,
      numero: item.Number,
      bairro: item.Neighborhood,
      complemento: item.Complement,
      cidade: item.City,
      uf: item.UF,
      retiradaDrivethru: item.DrivethruWithdrawal,
      retiradaNormal: item.NormalWithdrawal,
      retiradaModal: item.ModalSalesChannel,
      latitude: item.Latitude,
      longitude: item.Longitude,
      ordemExibicao: 0,
      retirada: item.Retirada,
      cepDelivery: item.ZipCodeWithdrawal,
      raioAtuacao: +item.DeliveryRadius,
      raiosAtuacao: RaioAtuacaoModel.toModelList(item.DeliveryRadiusList)
    } as LojaModel;
  }
}
